export default class ArrayHelper {
  /**
   * Splits an array into a specified number of parts, trying to keep the parts as equal as possible (the difference of length between the parts will be at most 1).
   */
  static splitArray = <T>(array: T[], parts: number): T[][] => {
    const splitArrays: T[][] = Array.from({ length: parts }, () => []);

    array.forEach((a, i) => splitArrays.at(i % parts)?.push(a));

    return splitArrays;
  };
}
